import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Select2Multiple from 'v-select2-multiple-component';
import axios from "axios";
import CONFIG from "@/assets/js/config.custom.js";
import ValidationService from "@/services/ValidationService";
import store from '../../../store';

import {
    required,
    integer,
    minValue,
    maxValue
} from "vuelidate/lib/validators";

export default {
    name: 'scoreSettingEdit',
    components: {
        MainLayout,
        Loading,
        Select2Multiple,
    },
    mixins: [ValidationService],
    data() {
        return {
            acdYearList: [],
            gradeList: [],
            isLoading: true,
            disabled: false,
            submitted: false,
            scoreData: {},
            noDataMsg: CONFIG.NO_DATA_FOUND,
        };
    },

    validations: {
        scoreData: {
            acd_year_id: {
                required,
                integer
            },
            campus_grade_id: {
                required,
                integer,
            },
            term_exam_rate: {
                integer,
                maxLength: maxValue(100),
                minValue: minValue(0)
            },
            unit_end_test_rate: {
                integer,
                maxLength: maxValue(100),
                minValue: minValue(0)
            },
            project_rate: {
                integer,
                maxLength: maxValue(100),
                minValue: minValue(0)
            },
        },
    },

    watch: {
        'scoreData.acd_year_id'(newVal, oldVal) {
            // User changed year (not initial load): clear grade, server errors, and submit state
            const isUserChange =
                oldVal !== undefined &&
                oldVal !== null &&
                oldVal !== '' &&
                String(oldVal) !== String(newVal);
            if (isUserChange) {
                this.scoreData.campus_grade_id = '';
                this.validationErrors = {};
                this.submitted = false;
                this.$nextTick(() => {
                    if (this.$v.scoreData.campus_grade_id) {
                        this.$v.scoreData.campus_grade_id.$reset();
                    }
                });
            }
            if (!newVal) {
                this.gradeList = [];
                return;
            }
            this.getGradeList(newVal);
        },
        'scoreData.campus_grade_id'() {
            if (this.validationErrors.campus_grade_id) {
                this.$delete(this.validationErrors, 'campus_grade_id');
            }
            this.$nextTick(() => {
                if (this.$v.scoreData.campus_grade_id) {
                    this.$v.scoreData.campus_grade_id.$reset();
                }
            });
        },
    },

    methods: {
        blockInvalidNumberInput(field) {
            let value = this.scoreData[field].replace(/[^0-9]/g, '');
            this.scoreData[field] = value;
        },

        async getParentAcdYearList() {
            try {
                const response = await axios.get('score-setting/parent-acd-year');
                if (response.data) {
                    const rawData = response.data.data;
                    this.acdYearList = rawData.map(item => ({
                        id: item.id,
                        text: item.period_name
                    }));
                }
            } catch (error) {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                console.error("Error fetching academic year list:", error);
            } finally {
                this.isLoading = false;
            }
        },

        getGradeList(yearId) {
            if (!yearId) {
                this.gradeList = [];
                this.isLoading = false;
                return;
            }
            axios.get('campusGrade/list-by-acdYear', {
                params: {
                    campus_id: store.state.user.campus_id,
                    acd_year_id: yearId,
                    get_grade: true,
                },
            }).then((res) => {
                const rows = Array.isArray(res.data) ? res.data : [];
                this.gradeList = rows.map((g) => ({
                    id: g.campus_grade_id,
                    text: g.grade_name,
                }));
                this.isLoading = false;
            }).catch((error) => {
                if (error.response?.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                console.error("Error fetching grade list:", error);
                this.isLoading = false;
            });
        },

        getScoreInfo() {
            this.isLoading = true;
            axios.get(`/score-setting/${this.$route.params.id}/info`)
                .then((res) => {
                    if (res.data) {
                        this.scoreData = res.data;
                        this.getParentAcdYearList();
                        // Grade list is loaded by watcher on scoreData.acd_year_id
                        this.isLoading = false;
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    console.error("Error fetching score info:", error);
                })
        },

        showList() {
            this.$router.push({
                path: "/score-setting"
            })
        },

        update() {
            this.$v.$touch();
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.clearValidationErrors();
            this.disabled = true;
            this.isLoading = true;
            const request = {
                acd_year_id: this.scoreData.acd_year_id,
                // term_id: this.scoreData.term_id,
                campus_grade_id: this.scoreData.campus_grade_id,
                term_exam_rate: this.scoreData.term_exam_rate,
                unit_end_test_rate: this.scoreData.unit_end_test_rate,
                project_rate: this.scoreData.project_rate,
            };
            axios.put(`/score-setting/${this.scoreData.id}`, request)
                .then((res) => {
                    this.disabled = false;
                    if (res.data.success === true) {
                        this.isLoading = false;
                        this.$notification.success(res.data.message, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.showList();
                    }
                })
                .catch(error => {
                    this.disabled = false;
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    } else if (error.response.status == 422) {
                        this.printValidationError(error.response);
                    }
                    this.isLoading = false;
                })
        }
    },

    mounted() {
        this.isLoading = true;
        this.getScoreInfo();
    },
};
